module.exports = __webpack_public_path__ + "static/media/phone.b04c3028.svg";